import { Brand } from "../models/Brand";
import axios, { AxiosResponse } from "axios";

const getBrands = async (): Promise<Brand[]> => {
  let response: AxiosResponse<Brand[]> = await axios.get("brands");
  return response.data;
};

export { getBrands };
